import { FaCheck } from "react-icons/fa";
import "./MarkCompleteButton.css";
import { Tooltip } from "../Tooltip";

export function MarkCompleteButton({ onClick, isActive }) {
  return (
    <div className="toolbar-button-wrapper">
      <button onClick={onClick} className="mark-complete-button">
        <FaCheck />
      </button>
      {isActive && <div className="button-underline mark-complete-underline" />}
    </div>
  );
}
